export default __webpack_public_path__ + "static/media/backInFive.702c1c8b.png";